import type { Room } from '../../entities/room/types';
import type { MessageKey } from '../i18n/messages';

type Translate = (key: MessageKey) => string;

/**
 * The one name a room goes by everywhere a player sees it: "Bronze room 1",
 * "Silver room 1" — tier plus its number among the same game's rooms of that
 * tier, ordered by room code so it never shuffles as people move. Always
 * numbered, even when the tier has a single room, because the hall list
 * numbers every row ("Room 1") and the room header must read the same.
 * The backend's own label ("Hall B") is an operator name and stays out of it.
 */
export function roomDisplayName(room: Room, rooms: Room[], t: Translate): string {
  const tier = String(room.tier || 'bronze').toLowerCase();
  return t('lobbyRoomDisplayNumbered')
    .replace('%tier%', t(`tier_${tier}` as MessageKey))
    .replace('%number%', String(roomNumberInTier(room, rooms)));
}

export function roomNumberInTier(room: Room, rooms: Room[]): number {
  const tier = String(room.tier || 'bronze').toLowerCase();
  const sameTier = rooms
    .filter((candidate) => candidate.game === room.game && String(candidate.tier || 'bronze').toLowerCase() === tier)
    .sort((a, b) => String(a.code || a.id).localeCompare(String(b.code || b.id)));
  const index = sameTier.findIndex((candidate) => candidate.id === room.id);
  return index === -1 ? 1 : index + 1;
}
